import { Container, Paper, Typography, Box } from '@mui/material';

export const AuthLayout = ({ children }) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #006494 0%, #004266 100%)',
        p: { xs: 1.5, sm: 2, md: 3 },
      }}
    >
      <Container component="main" maxWidth="sm">
        <Paper
          elevation={3}
          sx={{
            p: { xs: 2.5, sm: 3.5, md: 4 },
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: 3,
            boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
          }}
        >
          <Typography component="h1" variant="h4" sx={{ mb: 0.75, color: 'primary.main', fontWeight: 700 }}>
            LyraPOS
          </Typography>
          <Typography variant="body2" sx={{ mb: 4, color: 'text.secondary' }}>
            Hotel Billing System
          </Typography>
          {children}
        </Paper>
      </Container>
    </Box>
  );
};
